// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-head {
  height: 4rem;
  font-size: 1.1rem;
  background-color: #f8f9fA !important;
}

.table-line {
  border-bottom: 1px solid var(--surface-50) !important;
  height: 4rem;
}

::ng-deep .p-datatable .p-datatable-thead > tr > th {
  border: 0px solid #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/settings-form/settings-form-entities/settings-form-entities.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,oCAAA;AACJ;;AAEA;EACI,qDAAA;EACA,YAAA;AACJ;;AAEA;EACI,sBAAA;AACJ","sourcesContent":[".table-head {\n    height: 4rem;\n    font-size: 1.1rem;\n    background-color: #f8f9fA !important;\n}\n\n.table-line {\n    border-bottom: 1px solid var(--surface-50) !important;\n    height: 4rem;\n}\n\n::ng-deep .p-datatable .p-datatable-thead > tr > th {\n    border: 0px solid #fff;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
